import { IonIcon, IonInput, IonItem } from '@ionic/react';
import { useRef, useState } from 'react';
import './SearchBar.scss'
import { search, closeCircle } from 'ionicons/icons';
import { appSubDir } from '../../configs/app';
import SearchBarImageUpload from './SearchBarImageUpload';

const SearchBar: React.FC = () => {
    const [keyword, setKeyword] = useState<string>('')
    const inputRef = useRef<HTMLIonInputElement>(null)

    function handleSearch() {
        const trimmed = keyword.trim()
        if (trimmed) {
            window.location.href = appSubDir + 'search/' + encodeURIComponent(trimmed)
        }
    }

    function handleKeyDown(e: React.KeyboardEvent) {
        if (e.key === 'Enter') {
            handleSearch()
        }
    }

    function handleClear() {
        setKeyword('')
        inputRef.current?.setFocus()
    }

    const isMobile = window.innerWidth <= 600;

    if (isMobile) {
        return (
            <div id='search-bar-container' className="mobile-search-bar-container">
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSearch();
                    }}
                    className="mobile-search-form"
                >
                    <div className="mobile-search-input-wrapper">
                        <input
                            type="text"
                            placeholder="I am looking for..."
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                            onKeyDown={handleKeyDown}
                            className="mobile-search-input"
                        />
                        <button
                            type="button"
                            className={'mobile-clear-btn' + (keyword ? ' visible' : '')}
                            onClick={handleClear}
                            aria-label="Clear search"
                        >
                            <IonIcon icon={closeCircle} />
                        </button>
                        <div className="mobile-camera-btn">
                            <SearchBarImageUpload />
                        </div>
                    </div>
                    <button type="submit" className="mobile-search-btn">
                        <IonIcon icon={search} />
                    </button>
                </form>
            </div>
        );
    }

    return <>
        <div id='search-bar-container'>
            <IonItem className="search-bar">
                <SearchBarImageUpload />
                <IonInput
                    ref={inputRef}
                    value={keyword}
                    onIonChange={(e) => setKeyword(String(e.detail.value ?? ''))}
                    onKeyDown={handleKeyDown}
                    placeholder='I am looking for...'
                />
                <IonIcon
                    icon={closeCircle}
                    slot='end'
                    className={'clear-icon' + (keyword ? ' visible' : '')}
                    onClick={handleClear}
                />
                <IonIcon
                    icon={search}
                    slot='end'
                    style={{ cursor: 'pointer' }}
                    onClick={handleSearch}
                />
            </IonItem>
        </div>
    </>
};

export default SearchBar;
